<section>
  <div class="row" style="width: 480px;">

    <div class="pagination-count col-4 text-nowrap"><b>{{from}}</b> to <b>{{ to }}</b> of <b>{{totalElements}}</b></div>

    <div class="pagination col-8 text-nowrap d-flex justify-content-end">
      @if(odin){
<div class="col-4 text-end">

        <input type="number" min="1" [max]="totalElements"  (ngModelChange)="checkForChangeEvent($event)" 
 [(ngModel)]="selectedPageNumber"
          style="width: 70px; height:30px;; padding: 2px 4px; text-align: center;" />
      </div>
}
      
      <article class="pagination-page">
        <button (click)="this.startPage.emit()" style="border: 0; background-color: transparent;">
          <span class="material-icons-outlined text-secondary" style="font-size: 22px;">
            first_page
          </span>
        </button>&nbsp;&nbsp;
        <button (click)="this.previousPage.emit()" style="border: 0; background-color: transparent;">
          <span class="material-icons-outlined text-secondary" style="font-size: 22px;cursor: pointer;">
            chevron_left
          </span>
        </button>
        <span style="position: relative; top: -6px">&nbsp;&nbsp;Page <b>{{currentPage + 1}}</b> of
          <b>{{totalPages}}</b>&nbsp;&nbsp;</span>
        <button (click)="this.nextPage.emit();" style="border: 0; background-color: transparent;">
          <span class="material-icons-outlined text-secondary" style="font-size: 22px;cursor: pointer;">
            chevron_right
          </span>
        </button>
        &nbsp;&nbsp;
        <button (click)="this.finalPage.emit()" style="border: 0; background-color: transparent;">
          <span class="material-icons-outlined text-secondary" style="font-size: 22px;cursor: pointer;">
            last_page
          </span>
        </button>
        &nbsp;&nbsp;
      </article>
    </div>
  </div>
</section>